import {ACTIVATION_BRIEF_STATUS_NONE} from '../../../../constants/activation-brief';

export default {
    methods: {
        buildMockBrief(moduleName, activation) {
            return {
               ...activation,
                status: ACTIVATION_BRIEF_STATUS_NONE,
                activation,
            };
        },
    },
};
